import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BTechAICoursePage: React.FC = () => {
  const courseData = {
    title: "B.Tech. Artificial Intelligence and Data Science",
    shortName: "B.Tech AI & DS",
    duration: "4 years",
    description: "Cutting-edge engineering program focusing on AI, machine learning, data analytics, and intelligent systems",
    overview: "Bachelor of Technology in Artificial Intelligence and Data Science (B.Tech AI & DS) is a specialized 4-year undergraduate program that combines the fundamentals of computer science with advanced concepts in artificial intelligence, machine learning, data science, and analytics. This program prepares students to develop intelligent systems, analyze big data, and create AI-powered solutions for various industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Age: Maximum 25 years (30 for SC/ST)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Programming Fundamentals",
          "Statistics & Probability",
          "Linear Algebra"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures & Algorithms",
          "Python Programming",
          "Database Management Systems",
          "Discrete Mathematics",
          "Introduction to AI",
          "Data Analytics Fundamentals"
        ]
      },
      {
        year: 3,
        subjects: [
          "Machine Learning",
          "Deep Learning",
          "Natural Language Processing",
          "Computer Vision",
          "Big Data Analytics",
          "Data Mining & Warehousing"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced AI Algorithms",
          "Reinforcement Learning",
          "AI Ethics & Governance",
          "Industry Project",
          "Research Methodology",
          "Internship/Capstone Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "AI Engineer",
        "Machine Learning Engineer",
        "Data Scientist",
        "Data Analyst",
        "AI Research Scientist",
        "Deep Learning Engineer",
        "Computer Vision Engineer",
        "NLP Engineer",
        "Business Intelligence Analyst",
        "AI Product Manager"
      ],
      industries: [
        "Technology Companies",
        "Healthcare & Pharmaceuticals",
        "Financial Services",
        "Automotive Industry",
        "E-commerce & Retail",
        "Gaming & Entertainment",
        "Consulting Services",
        "Research Institutions",
        "Government & Defense",
        "Startups & Innovation Labs"
      ],
      averageSalary: "₹6-25 LPA",
      topRecruiters: [
        "Google",
        "Microsoft",
        "Amazon",
        "IBM",
        "NVIDIA",
        "Intel",
        "Flipkart",
        "Uber",
        "Netflix",
        "Tesla"
      ]
    },

    topColleges: [
      {
        name: "Indian Institute of Technology (IIT) Hyderabad",
        location: "Telangana",
        fees: "₹2,50,000/year",
        ranking: "1"
      },
      {
        name: "Indian Institute of Technology (IIT) Delhi",
        location: "New Delhi",
        fees: "₹2,50,000/year",
        ranking: "2"
      },
      {
        name: "Vellore Institute of Technology",
        location: "Tamil Nadu",
        fees: "₹2,20,000/year",
        ranking: "3"
      },
      {
        name: "SRM Institute of Science & Technology",
        location: "Tamil Nadu",
        fees: "₹2,75,000/year",
        ranking: "4"
      },
      {
        name: "Manipal Institute of Technology",
        location: "Karnataka",
        fees: "₹3,20,000/year",
        ranking: "5"
      }
    ],

    skills: [
      "Python & R Programming",
      "Machine Learning Algorithms",
      "Deep Learning Frameworks (TensorFlow, PyTorch)",
      "Data Visualization",
      "Statistical Analysis",
      "Natural Language Processing",
      "Computer Vision",
      "Big Data Tools (Hadoop, Spark)",
      "Cloud Platforms (AWS, GCP, Azure)",
      "Mathematical Modeling"
    ],

    futureScope: "B.Tech AI & Data Science graduates are in high demand across industries undergoing digital transformation. Career prospects include AI research, product development, data-driven decision making, and innovation leadership. With AI becoming integral to business operations, graduates can pursue advanced research, entrepreneurship, or leadership roles in emerging technologies like autonomous systems, healthcare AI, and smart city solutions.",

    faqs: [
      {
        question: "Is mathematics important for AI and Data Science?",
        answer: "Yes, strong mathematical foundation in statistics, linear algebra, calculus, and probability is crucial for understanding AI algorithms and data science concepts."
      },
      {
        question: "What programming languages should I learn?",
        answer: "Python and R are primary languages for AI/DS, along with SQL for databases. Knowledge of Java, C++, and JavaScript is also beneficial."
      },
      {
        question: "Can I work in any industry with AI & DS skills?",
        answer: "Yes, AI and Data Science applications span across healthcare, finance, retail, automotive, entertainment, and virtually every industry sector."
      },
      {
        question: "What are the research opportunities in this field?",
        answer: "Extensive research opportunities exist in areas like autonomous systems, healthcare AI, climate modeling, robotics, and human-computer interaction."
      },
      {
        question: "How different is this from regular Computer Science?",
        answer: "While CSE covers broad computing concepts, AI & DS specializes in intelligent systems, machine learning, data analytics, and statistical computing with domain-specific applications."
      }
    ],

    admissionProcess: [
      "JEE Main Qualification",
      "State CET Examination (for state colleges)",
      "Choice Filling & Counseling",
      "Seat Allotment",
      "Document Verification",
      "Fee Payment & Admission Confirmation"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BTechAICoursePage;
